import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Drawer,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import BannerSection from "../../components/common/BannerSection";
import { useDispatch, useSelector } from "react-redux";
import { fetchCmsHomeAction } from "../../store/slices/cmsSlice";

const ReturnPolicyPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const dispatch = useDispatch();
  const cmsHome = useSelector((state) => state.cms.home);

  useEffect(() => {
    if (!cmsHome) {
      dispatch(fetchCmsHomeAction());
    }
  }, [cmsHome, dispatch]);

  const { title, descriptionHtml } = useMemo(() => {
    const data = Array.isArray(cmsHome?.data) ? cmsHome.data : [];
    const section = data.find((s) => s?.id === 73);
    return {
      title: section?.title || "",
      descriptionHtml: section?.description || "",
    };
  }, [cmsHome]);

  return (
    <Box sx={{ backgroundColor: "#fff" }}>
      <Box sx={{ mb: isMobile ? "10px" : "40px", mt: isMobile ? "0" : "30px" }}>
        <BannerSection title={title} subtitle="" />
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          maxWidth: "1360px",
          mx: "auto",
          px: "16px",
        }}
      >
        <Box sx={{ display: "flex", flexGrow: 1, gap: "14px" }}>
          <Box
            sx={{
              flexGrow: 1,
              border: "1px solid #F1F1F1",
              p: "20px",
              borderRadius: "12px",
              backgroundColor: "#FFFFFF",
            }}
          >
            <Paper elevation={0} sx={{ borderRadius: 2 }}>
              <Box
                sx={{ color: "#4A4A49", fontSize: "14px", lineHeight: "22px", '& *': { color: '#4A4A49 !important' }, '& ul': { listStyle: 'disc', paddingLeft: '20px', marginTop: '8px', marginBottom: '8px' }, '& li': { listStyle: 'disc', display: 'list-item' } }}
                dangerouslySetInnerHTML={{ __html: descriptionHtml || "" }}
              />
            </Paper>
          </Box>
        </Box>
      </Box>

    </Box>
  );
};

export default ReturnPolicyPage;
